export const UserKeys = {
    paging: 'getUserPaging',
    delete: 'deleteUser',
    get: 'getUserById',
    create: 'createUser',
    update: 'updateUser',
    getRoleMapping: 'getUserRoleMapping',
    addRoleMapping: 'addUserRoleMapping',
    deleteRoleMapping: 'deleteUserRoleMapping',
    getApplicationMapping: 'getUserApplicationMapping',
    addApplicationMapping: 'addUserApplicationMapping',
    deleteApplicationMapping: 'deleteUserApplicationMapping',
    notInRoles: 'userNotInRoles',
    notInApplications: 'userNotInApplications',
}